// Compiled at 2026-05-13T13:50:05.286Z
import * as LowgileDataUtil from "@lg/shared";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { Llama, Llama as This, System, Common } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
// Auto-generated by Lowgile
import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter, ChangeDetectionStrategy, inject, input, signal, computed, effect, linkedSignal, viewChild } from "@angular/core";
import { AppState, app } from "../../ClientDataStore/$state";
import { AbstractScreen } from "@lg/ng-shared";
import { ValidationRules, BoInfoSymbol } from "@lg/shared";
import { ProxyTargetSymbol } from "@lg/shared";
import { Semaphore } from "@lg/shared";
import { memoize } from "@lg/shared";
import { combineLatest } from "rxjs";
import { ProcessTaskComponent } from "../../components/process-task.component";
import { proxySignal, ProxySignal } from "../../signals.js";

interface Properties {
    expenses: This.Expense[];
    projectsOptions: This.Project[];
}

interface State {
    app: AppState;
    screen: Properties;
}

@Component({
    selector: 'Llama-VerifyExpenses',
    templateUrl: './VerifyExpenses.html',
    styleUrls: ['./VerifyExpenses.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class VerifyExpenses extends AbstractScreen implements OnInit, AfterViewInit {
    static readonly $canBeMainScreen = true;
    static readonly $canBeDialogScreen = true;
    readonly $qualifiedScreenName = 'Llama.VerifyExpenses';
    $isDialog = false;
    $Modules = $Modules;
    Llama = Llama;
    System = System;
    Common = Common;
    Sys = Sys;
    This = This;
    app = app;
    $scope = {};
    $pathSegments: string[] = [];
    $processTaskComponent = inject(ProcessTaskComponent, { optional: true });
    output = {

    };
    $validators: Record<number, ValidationRules> = {

    };
    var_expenses = proxySignal<This.Expense[]>(undefined as any);
    var_projectsOptions = proxySignal<This.Project[]>(undefined as any);
    readonly screen =
        ((component: typeof this) => {
            return {
                get expenses() { return component.var_expenses() },
                set expenses(value: This.Expense[]) { component.var_expenses.set(value) },
                get projectsOptions() { return component.var_projectsOptions() },
                set projectsOptions(value: This.Project[]) { component.var_projectsOptions.set(value) }
            }
        })(this)
        ;

    get $inputs() {
        return {

        }
    }

    async ngOnInit(): Promise<void> {
        super.ngOnInit()
        if (!this.$processTaskComponent) {
            this.processService.tokenId.set(undefined)
        }


    }

    async ngAfterViewInit(): Promise<void> {
    }

    constructor() {

        super()

        effect(() => {
            if (!this.authService.isInitialized()) return
            const isVariablesInitialized = this.$isVariablesInitialized()
            const { screen, app } = this
            if (!isVariablesInitialized) this.screen.expenses = ([])
            if (!isVariablesInitialized) this.screen.projectsOptions = ([])
            this.$isVariablesInitialized.set(true)
        })

        effect(() => {
            if (!this.$isVariablesInitialized()) return
            if (!this.$isOnInitCalled) {
                this.$isOnInitCalled = true
                setTimeout(async () => {
                    await this.action_onInit()
                    this.$isFullyInitialized.set(true)
                })
            }
        })

    }

    async action_onInit($event?: any) {
        const { app, screen, output } = this
        {
            Sys.App.spinnerText = 'Loading...'

            screen.projectsOptions = await This.ExpensesDataStore.loadByCondition(This.Project, {
                where: {
                    isActive: true
                },
                order: {
                    createdOn: 'asc',
                },
            })

            await this.action_loadExpenses($event)
        }
    }

    async action_verifyExpense(expense: This.Expense, $event?: any) {
        const { app, screen, output } = this
        {
            await This.ReceiptHelper.verifyExpense(expense);
            await this.action_loadExpenses($event);
        }
    }

    async action_loadExpenses($event?: any) {
        const { app, screen, output } = this
        {
            screen.expenses = await This.ExpensesDataStore.loadByCondition(This.Expense, {
                where: {
                    status$id: This.ExpenseStatus.unverified.id,
                    employeeEmail: Sys.User.currentUser.email,
                },
                relations: {
                    receipts: true
                }
            })

            Sys.App.spinnerText = null
        }
    }
}
